import React from "react";

import { Container } from "react-bootstrap";

const Pay = () => {
  return (
    <div className="mt-5">
      <Container>
        <h2>Pay</h2>
      </Container>
    </div>
  );
};

export default Pay;
